module.exports = __webpack_public_path__ + "./fonts/Kobe1.1-Bold.otf";